module.exports = __webpack_public_path__ + "static/media/masthead-harvey-waroona-reporter.e44d8ec2.svg";